import React, { Component, PropTypes } from 'react';
import './style.css';

export default class Notification extends Component {
    static proptypes = {
        type: PropTypes.oneOf(['success', 'danger']).isRequired,
        show: PropTypes.bool.isRequired,
        message: PropTypes.string.isRequired
    };

    render() {
        const {type, show, message} = this.props;

        let hidden = show ? 'show' : '';

        return (
            <div className={`notification notif-${type} ${hidden}`}>
                <p id="message" className="text-center">
                    {message}
                </p>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Notification/index.js
 **/